"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPlayersResponseDto = instanceOfPlayersResponseDto;
exports.PlayersResponseDtoFromJSON = PlayersResponseDtoFromJSON;
exports.PlayersResponseDtoFromJSONTyped = PlayersResponseDtoFromJSONTyped;
exports.PlayersResponseDtoToJSON = PlayersResponseDtoToJSON;
exports.PlayersResponseDtoToJSONTyped = PlayersResponseDtoToJSONTyped;
var TeamPlayersGroupDto_1 = require("./TeamPlayersGroupDto");
/**
 * Check if a given object implements the PlayersResponseDto interface.
 */
function instanceOfPlayersResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function PlayersResponseDtoFromJSON(json) {
    return PlayersResponseDtoFromJSONTyped(json, false);
}
function PlayersResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : (json['data'].map(TeamPlayersGroupDto_1.TeamPlayersGroupDtoFromJSON)),
        'error': json['error'] == null ? undefined : json['error'],
        'errorCode': json['errorCode'] == null ? undefined : json['errorCode'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function PlayersResponseDtoToJSON(json) {
    return PlayersResponseDtoToJSONTyped(json, false);
}
function PlayersResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : (value['data'].map(TeamPlayersGroupDto_1.TeamPlayersGroupDtoToJSON)),
        'error': value['error'],
        'errorCode': value['errorCode'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
